export const ReviewData = [
  {
    id: 1,
    name: "Roopali",
    initial: "R",
    location: "India",
    rating: 5,
    comment: {
      title: "excellent customer service",
      text: "excellent customer service, beat designs, awesome delivery timing"
    },
    date: "February 09 2025",
    bgColor: "pink"
  },
  {
    id: 2,
    name: "Saraf Sadique",
    initial: "S",
    location: "United States of America",
    rating: 5,
    comment: {
      title: "Great Outfit and Quality!",
      text:
        "I absolutely love my outfit! I had requested a blouse alteration and it turned out beautiful, very very close to the original design. I am extremely happy with my purchase."
    },
    date: "February 09 2025",
    bgColor: "blue"
  },
  {
    id: 3,
    name: "Laura Mclaughlin",
    initial: "L",
    location: "United States of America",
    rating: 5,
    comment: {
      title: "The dress is so beautiful",
      text: "The dress is so beautiful! And it arrived ahead of schedule"
    },
    date: "February 09 2025",
    bgColor: "purple"
  },
  {
    id: 4,
    name: "Customer",
    initial: "C",
    location: "United States of America",
    rating: 5,
    comment: {
      title: "Have purchased from here multiple times",
      text:
        "Have purchased from here multiple times. Love the variety and sales. Easy to order and always on time."
    },
    date: "February 09 2025",
    bgColor: "green"
  },
  {
    id: 5,
    name: "Jennifer",
    initial: "J",
    location: "Canada",
    rating: 5,
    comment: {
      title: "Amazing quality products",
      text:
        "The quality of the products exceeded my expectations. Will definitely shop here again!"
    },
    date: "February 08 2025",
    bgColor: "pink"
  },
  {
    id: 6,
    name: "Michael",
    initial: "M",
    location: "United Kingdom",
    rating: 4,
    comment: {
      title: "Fast shipping",
      text:
        "Products arrived earlier than expected. Great communication throughout the process."
    },
    date: "February 07 2025",
    bgColor: "blue"
  },
  {
    id: 7,
    name: "Anthony",
    initial: "A",
    location: "United States of America",
    rating: 5,
    comment: {
      title: "Have purchased from here multiple times",
      text:
        "Have purchased from here multiple times. Love the variety and sales. Easy to order and always on time."
    },
    date: "February 09 2025",
    bgColor: "green"
  },
  {
    id: 8,
    name: "Jennifer",
    initial: "J",
    location: "Canada",
    rating: 5,
    comment: {
      title: "Amazing quality products",
      text:
        "The quality of the products exceeded my expectations. Will definitely shop here again!"
    },
    date: "February 08 2025",
    bgColor: "pink"
  },
  {
    id: 9,
    name: "Michael",
    initial: "M",
    location: "United Kingdom",
    rating: 4,
    comment: {
      title: "Fast shipping",
      text:
        "Products arrived earlier than expected. Great communication throughout the process."
    },
    date: "February 07 2025",
    bgColor: "blue"
  }
];
